import React, { useEffect, useMemo, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { API_BASE } from "../config/orbisConfig";

export default function AlertCenter() {
    const navigate = useNavigate();
    const location = useLocation();
    const panelRef = useRef(null);

    const [open, setOpen] = useState(false);
    const [loading, setLoading] = useState(false);
    const [alerts, setAlerts] = useState([]);

    const unreadCount = useMemo(
        () => alerts.filter((a) => Number(a.is_read || 0) !== 1).length,
        [alerts]
    );

    const token =
        localStorage.getItem("cani_auth") ||
        localStorage.getItem("token") ||
        "";

    const loggedUserId =
        Number(localStorage.getItem("user_id")) ||
        Number(localStorage.getItem("id")) ||
        1;

    const loadAlerts = async () => {
        try {
            setLoading(true);

            const response = await fetch(`${API_BASE}/alerts.php?user_id=${loggedUserId}`, {
                headers: {
                    Authorization: token ? `Bearer ${token}` : "",
                    "X-CANI-AUTH": token || "",
                },
            });

            const text = await response.text();
            if (!text || !text.trim()) {
                setAlerts([]);
                return;
            }

            const result = JSON.parse(text);

            if (!response.ok || !result.success) {
                setAlerts([]);
                return;
            }

            setAlerts(Array.isArray(result.data) ? result.data : []);
        } catch {
            setAlerts([]);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        loadAlerts();
        const interval = setInterval(loadAlerts, 30000);
        return () => clearInterval(interval);
    }, []);

    useEffect(() => {
        const onClickOutside = (e) => {
            if (!panelRef.current) return;
            if (!panelRef.current.contains(e.target)) {
                setOpen(false);
            }
        };

        document.addEventListener("mousedown", onClickOutside);
        return () => document.removeEventListener("mousedown", onClickOutside);
    }, []);

    const markOneAsRead = async (alertId) => {
        try {
            await fetch(`${API_BASE}/alerts.php`, {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: token ? `Bearer ${token}` : "",
                    "X-CANI-AUTH": token || "",
                },
                body: JSON.stringify({
                    user_id: loggedUserId,
                    alert_id: alertId,
                    action: "mark_read",
                }),
            });

            setAlerts((prev) =>
                prev.map((a) =>
                    Number(a.id) === Number(alertId) ? { ...a, is_read: 1 } : a
                )
            );
        } catch { }
    };

    const markAllAsRead = async () => {
        try {
            await fetch(`${API_BASE}/alerts.php`, {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: token ? `Bearer ${token}` : "",
                    "X-CANI-AUTH": token || "",
                },
                body: JSON.stringify({
                    user_id: loggedUserId,
                    action: "mark_all_read",
                }),
            });

            setAlerts((prev) => prev.map((a) => ({ ...a, is_read: 1 })));
        } catch { }
    };

    const getReturnContext = () => {
        const currentPath = `${location.pathname}${location.search || ""}`;

        if (location.pathname.startsWith("/roadmap")) {
            return {
                returnTo: currentPath,
                returnLabel: "Roadmap Ejecutivo",
            };
        }

        if (location.pathname.startsWith("/gantt")) {
            return {
                returnTo: currentPath,
                returnLabel: "Gantt PMO",
            };
        }

        if (location.pathname.startsWith("/kanban")) {
            return {
                returnTo: currentPath,
                returnLabel: "Kanban PMO",
            };
        }
        if (location.pathname.startsWith("/my-work")) {
            return {
                returnTo: currentPath,
                returnLabel: "Mi trabajo",
            };
        }
        if (location.pathname.startsWith("/dashboardexecutive")) {
            return {
                returnTo: currentPath,
                returnLabel: "Dashboard Ejecutivo",
            };
        }

        if (location.pathname.startsWith("/projects")) {
            return {
                returnTo: currentPath,
                returnLabel: "Ficha 360",
            };
        }

        return {
            returnTo: "/dashboardexecutive",
            returnLabel: "Dashboard Ejecutivo",
        };
    };

    const openAlert = async (alert) => {
        if (Number(alert.is_read || 0) !== 1) {
            await markOneAsRead(alert.id);
        }

        setOpen(false);

        const alertType = String(alert.alert_type || "").toLowerCase();

        if (alert.task_id) {
            const qp = new URLSearchParams();
            const returnContext = getReturnContext();


            if (alertType === "task_review") {
                qp.set("mode", "review");
            } else {
                qp.set("mode", "progress");
            }

            qp.set("return_to", returnContext.returnTo);
            qp.set("return_label", returnContext.returnLabel);

            navigate(`/my-work/task/${alert.task_id}?${qp.toString()}`);
            return;
        }

        if (alert.project_id) {
            navigate(`/projects/${alert.project_id}`);
            return;
        }

        navigate("/dashboardexecutive");
    };
    return (
        <div
            ref={panelRef}
            style={{
                position: "relative",
                zIndex: 999999,
            }}
        >
            <button
                type="button"
                onClick={() => setOpen((prev) => !prev)}
                style={{
                    width: 38,
                    height: 38,
                    borderRadius: 12,
                    border: "1px solid #d1d5db",
                    background: "#fff",
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    position: "relative",
                    cursor: "pointer",
                }}
                title="Alertas"
            >
                <BellIcon />
                {unreadCount > 0 ? (
                    <span
                        style={{
                            position: "absolute",
                            top: -4,
                            right: -4,
                            minWidth: 20,
                            height: 20,
                            padding: "0 6px",
                            borderRadius: 999,
                            background: "#b91c1c",
                            color: "#fff",
                            fontSize: 11,
                            fontWeight: 800,
                            display: "inline-flex",
                            alignItems: "center",
                            justifyContent: "center",
                        }}
                    >
                        {unreadCount}
                    </span>
                ) : null}
            </button>

            {open ? (
                <div
                    style={{
                        position: "absolute",
                        top: 46,
                        right: 0,
                        width: 380,
                        maxHeight: 520,
                        overflowY: "auto",
                        background: "#fff",
                        border: "1px solid #e5e7eb",
                        borderRadius: 16,
                        boxShadow: "0 24px 70px rgba(15, 23, 42, 0.24)",
                        zIndex: 999999,
                    }}
                >                    <div
                        style={{
                            padding: 14,
                            borderBottom: "1px solid #e5e7eb",
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                        }}
                    >
                        <div>
                            <div style={{ fontSize: 15, fontWeight: 800, color: "#111827" }}>
                                Alertas
                            </div>
                            <div style={{ fontSize: 12, color: "#6b7280" }}>
                                {unreadCount} sin leer
                            </div>
                        </div>

                        <button
                            type="button"
                            onClick={markAllAsRead}
                            style={{
                                border: "1px solid #d1d5db",
                                background: "#fff",
                                borderRadius: 10,
                                padding: "8px 10px",
                                cursor: "pointer",
                                fontSize: 12,
                                fontWeight: 700,
                            }}
                        >
                            Marcar todas
                        </button>
                    </div>

                    <div style={{ padding: 12 }}>
                        {loading ? (
                            <div style={{ padding: 12, color: "#6b7280" }}>
                                Cargando alertas...
                            </div>
                        ) : alerts.length === 0 ? (
                            <div
                                style={{
                                    padding: 16,
                                    border: "1px dashed #d1d5db",
                                    borderRadius: 12,
                                    color: "#6b7280",
                                    background: "#fafafa",
                                }}
                            >
                                No hay alertas activas.
                            </div>
                        ) : (
                            <div style={{ display: "grid", gap: 10 }}>
                                {alerts.map((alert) => (
                                    <button
                                        key={alert.id}
                                        type="button"
                                        onClick={() => openAlert(alert)}
                                        style={{
                                            textAlign: "left",
                                            border: Number(alert.is_read || 0) === 1
                                                ? "1px solid #e5e7eb"
                                                : "1px solid #fecaca",
                                            background: Number(alert.is_read || 0) === 1
                                                ? "#fff"
                                                : "#fff7f7",
                                            borderRadius: 12,
                                            padding: 12,
                                            cursor: "pointer",
                                            width: "100%",
                                        }}
                                    >
                                        <div
                                            style={{
                                                display: "flex",
                                                justifyContent: "space-between",
                                                gap: 8,
                                                alignItems: "flex-start",
                                                marginBottom: 6,
                                            }}
                                        >
                                            <div>
                                                <div style={{ fontWeight: 800, color: "#111827" }}>
                                                    {alert.title || "Alerta"}
                                                </div>

                                                {alert.task_name ? (
                                                    <div
                                                        style={{
                                                            marginTop: 3,
                                                            fontSize: 12,
                                                            color: "#1D4ED8",
                                                            fontWeight: 900,
                                                        }}
                                                    >
                                                        {alert.wbs_code ? `${alert.wbs_code} · ` : ""}
                                                        {alert.task_name}
                                                    </div>
                                                ) : null}

                                                {alert.project_name ? (
                                                    <div
                                                        style={{
                                                            marginTop: 2,
                                                            fontSize: 11,
                                                            color: "#64748B",
                                                            fontWeight: 750,
                                                        }}
                                                    >
                                                        Proyecto: {alert.project_name}
                                                    </div>
                                                ) : null}
                                            </div>
                                            {Number(alert.is_read || 0) !== 1 ? (
                                                <span
                                                    style={{
                                                        minWidth: 10,
                                                        height: 10,
                                                        borderRadius: "50%",
                                                        background: "#dc2626",
                                                        display: "inline-block",
                                                        marginTop: 4,
                                                    }}
                                                />
                                            ) : null}
                                        </div>

                                        <div
                                            style={{
                                                fontSize: 13,
                                                color: "#374151",
                                                marginBottom: 8,
                                                lineHeight: 1.35,
                                                fontWeight: 650,
                                            }}
                                        >
                                            {alert.message || "Sin detalle"}
                                        </div>

                                        <div
                                            style={{
                                                display: "flex",
                                                justifyContent: "space-between",
                                                gap: 8,
                                                alignItems: "center",
                                                flexWrap: "wrap",
                                            }}
                                        >
                                            <span style={{ fontSize: 11, color: "#6b7280", fontWeight: 700 }}>
                                                {alert.created_at || "—"}
                                            </span>

                                            <span
                                                style={{
                                                    fontSize: 10,
                                                    color: alert.task_id ? "#1D4ED8" : alert.project_id ? "#7C3AED" : "#64748B",
                                                    background: alert.task_id ? "#EFF6FF" : alert.project_id ? "#F5F3FF" : "#F8FAFC",
                                                    border: alert.task_id ? "1px solid #BFDBFE" : alert.project_id ? "1px solid #DDD6FE" : "1px solid #E2E8F0",
                                                    padding: "4px 8px",
                                                    borderRadius: 999,
                                                    fontWeight: 900,
                                                }}
                                            >
                                                {alert.task_id ? "Atender tarea" : alert.project_id ? "Ver proyecto" : "Ver dashboard"}
                                            </span>
                                        </div>
                                    </button>
                                ))}
                            </div>
                        )}
                    </div>
                </div>
            ) : null}
        </div>
    );
}

function BellIcon() {
    return (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <path
                d="M15 17H9M18 17V11C18 7.68629 15.3137 5 12 5C8.68629 5 6 7.68629 6 11V17L4.5 18.5H19.5L18 17ZM13.73 21C13.5542 21.3031 13.3011 21.5547 12.9969 21.7287C12.6927 21.9026 12.348 21.9928 11.9975 21.99C11.647 21.9872 11.3038 21.8914 11.0024 21.7126C10.7009 21.5338 10.4519 21.2782 10.281 20.9723"
                stroke="currentColor"
                strokeWidth="1.8"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}
